import { appConstantsFactory } from "app/app.module";

const appConstants = appConstantsFactory();
export default {
    accessTokenLocalStoragePath: `${appConstants?.openid?.id}:token`,
    project: 'supplierProfile',
    baseApiUrl: `${appConstants?.PUBLIC_URL}`,
};
